import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from '../utils/axiosInstance';
import * as XLSX from 'xlsx';
import './taxpayer.css';

function Taxpayer( {authenticatedUser, isLoading, isAdmin} ) {  

  const navigate = useNavigate();
  const location = useLocation();

  const [tpName, setTPName] = useState('')
  const [opNum, setOpNum] = useState('')
  const [lowpro, setLowPro] = useState('0.00')
  const [mktcosts, setMktCosts] = useState('0.00')
  const [highCost, setHighCost] = useState('0.00')
  const [highCostExpiring, setHighCostExpiring] = useState('0.00')
  const [address, setAddress] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [officers, setOfficers] = useState([])
  const [showOfficers, setShowOfficers] = useState(false)
  const [lastUpdatedDate, setLastUpdatedDate] = useState('')
  const [drillingPermits, setDrillingPermits] = useState('')
  const [oilDict, setOilDict] = useState({_2026:null, _2025:null, _2024:null, _2023:null, _2022:null})
  const [gasDict, setGasDict] = useState({_2026:null, _2025:null, _2024:null, _2023:null, _2022:null})
  const [clientInfo, setClientInfo] = useState({clientStatus:'N/A', auditor:null, note:null})
  const [newDrillPermits, setNewDrillPermits] = useState('0')
  const [TwoYrInactive, setTwoYrInactive] = useState('0.00')
  const [lowProExpiring, setLowProExpiring] = useState('0.00')
  const [recompletions, setRecompletions] = useState('0')

  const [taxpayerInfo, setTaxpayerInfo] = useState([])

  /*const lowProDetail = useRef([]);
  const lowProSummary= useRef([]);
  const lowProPurchasers =useRef([]);

  const highCostDetail = useRef([]);

  const twoYearCO = useRef([]);
  const twoYearNG = useRef([]);
  const twoYearPurchasers = useRef([]);

  const mktCostsProd = useRef([]);
  const mktCostsPurch = useRef([]);*/

  const [tempTP, setTempTP] = useState('');

  const [gettingResults, setGettingResults] = useState(true);

  useEffect(() => {
    if (authenticatedUser === null) {
      return;
    } 

    if(authenticatedUser === false){
        //console.log('authenticatedUser is null sending to login page')
        navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticatedUser]);

  useEffect(() => {
    //setGettingResults(true)

    if(!location.state)
      setTempTP('32054404077')
    else {
      setTempTP(location.state.data.TPNumber)
    }
    
    const getTaxpayerData = async() => {
      console.log("getting lowpro")
      setGettingResults(true)
      try {
        await axiosInstance.get('/lowpro/' + tempTP, {withCredentials:true})
        .then(response => {
          setTPName(response.data[0][0].TaxpayerName)

          if(response.data[1][0] !== undefined){
            //console.log('LowPro: ' + response.data[1][0])
            setLowPro(response.data[1][0].LowPro);
          }

          if(response.data[2][0] !== undefined)
            setMktCosts(response.data[2][0].MktCosts);

          if(response.data[3][0] !== undefined)
            setAddress(response.data[3][0].Address);
          else
            setAddress("N/A");

          if(response.data[4][0] !== undefined)
            setPhoneNumber(response.data[4][0].Phone);
          else
            setPhoneNumber("N/A");

          if(response.data[5] !== undefined) {
            setOfficers(response.data[5])
          }
          else console.log("No officer data");

          setLastUpdatedDate(response.data[6][0].UpdatedDate);

          setDrillingPermits(response.data[7][0].NumOfPermits);
          
          if(response.data[8][0] !== undefined){
            setOpNum(response.data[8][0].OperatorID)
            setOilDict(prevDict => ({ ...prevDict, _2026: response.data[8][0]._2026 }));
            setOilDict(prevDict => ({ ...prevDict, _2025: response.data[8][0]._2025 }));
            setOilDict(prevDict => ({ ...prevDict, _2024: response.data[8][0]._2024 }));
            setOilDict(prevDict => ({ ...prevDict, _2023: response.data[8][0]._2023 }));
            setOilDict(prevDict => ({ ...prevDict, _2022: response.data[8][0]._2022 }));
          }

          if(response.data[9][0] !== undefined){
            setGasDict(prevDict => ({ ...prevDict, _2026: response.data[9][0]._2026 }));
            setGasDict(prevDict => ({ ...prevDict, _2025: response.data[9][0]._2025 }));
            setGasDict(prevDict => ({ ...prevDict, _2024: response.data[9][0]._2024 }));
            setGasDict(prevDict => ({ ...prevDict, _2023: response.data[9][0]._2023 }));
            setGasDict(prevDict => ({ ...prevDict, _2022: response.data[9][0]._2022 }));
          }

          if(response.data[10][0] !== undefined){
            setClientInfo(prevClient => ({ ...prevClient, clientStatus: response.data[10][0]['ClientStatus']}));
            setClientInfo(prevClient => ({ ...prevClient, auditor: response.data[10][0]['Assigned To']})); 
            setClientInfo(prevClient => ({ ...prevClient, note: response.data[10][0]['MKT RPT NOTE']}));
          }
          else{
            console.log("No Client Info");
          }

          if(response.data[11][0] !== undefined)
            setHighCost(response.data[11][0].HighCost)

          if(response.data[12][0] !== undefined)
            setHighCostExpiring(response.data[12][0].RefundExpiring)

          if(response.data[13][0] !== undefined)
            setNewDrillPermits(response.data[13][0].NewWellsDrilled)
          
          if(response.data[14][0] !== undefined)
            setTwoYrInactive(response.data[14][0].TwoYrInactive)

          if(response.data[15][0] !== undefined)
            setLowProExpiring(response.data[15][0].LPExpiring)

          setTaxpayerInfo(response.data[16][0])

          if(response.data[17][0] !== undefined)
            setRecompletions(response.data[17][0].Recompletions)
        })
        .catch(error => console.error('Error fetching lowpros:', error));

        /*if(isAdmin)
          await axiosInstance.post('/getRefundDetails', {data: {tp: tempTP}}, {withCredentials:true})
          .then(response => {
            lowProDetail.current = response.data[0]
            lowProSummary.current = response.data[1]
            lowProPurchasers.current = response.data[2]
            highCostDetail.current = response.data[3]
            twoYearCO.current = response.data[4]
            twoYearNG.current = response.data[5]
            twoYearPurchasers.current = response.data[6]
            mktCostsProd.current = response.data[7]
            mktCostsPurch.current = response.data[8]
          })
          .catch(error => console.error('Error fetching details:', error));*/

      } finally {
        console.log("finished getting lowpro")
        setGettingResults(false)
      }
    };

    if(tempTP === location.state.data.TPNumber)
      getTaxpayerData();
      
  }, [location, tempTP, isAdmin]);

  const lowProToExcel = async() => {    
    const response = await axiosInstance.post('/getLowProDetails', {data: {tp: tempTP}}, {withCredentials:true, responseType: 'blob'})
    
    // Construct object URL out of the downloaded spreadsheet raw data
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    // Create an invisible anchor tag to trigger browser download prompt
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', tempTP + '_LowPro.xlsx');
    document.body.appendChild(link);

    link.click();

    // Clean up DOM and memory references
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const highCostToExcel = async() => {
    const response = await axiosInstance.post('/getHighCostDetails', {data: {tp: tempTP}}, {withCredentials:true, responseType: 'blob'})
    
    // Construct object URL out of the downloaded spreadsheet raw data
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    // Create an invisible anchor tag to trigger browser download prompt
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', tempTP + '_HighCost.xlsx');
    document.body.appendChild(link);

    link.click();

    // Clean up DOM and memory references
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const twoYrToExcel = async() => {
    const response = await axiosInstance.post('/getTwoYrDetails', {data: {tp: tempTP}}, {withCredentials:true, responseType: 'blob'})
    
    // Construct object URL out of the downloaded spreadsheet raw data
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    // Create an invisible anchor tag to trigger browser download prompt
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', tempTP + '_TwoYrInactive.xlsx');
    document.body.appendChild(link);

    link.click();

    // Clean up DOM and memory references
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const mktCostsToExcel = async() => {  
    const response = await axiosInstance.post('/getMktCostDetails', {data: {tp: tempTP}}, {withCredentials:true, responseType: 'blob'})
    
    // Construct object URL out of the downloaded spreadsheet raw data
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    // Create an invisible anchor tag to trigger browser download prompt
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', tempTP + '_MktCosts.xlsx');
    document.body.appendChild(link);

    link.click();

    // Clean up DOM and memory references
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const changeOfficers = () => {
    if(showOfficers === false){
      setShowOfficers(true);
    }
    else{
      setShowOfficers(false);
    }
  }

  if(gettingResults){
    return <div className="taxpayer-app"> <h1>Loading Taxpayer Page...</h1> </div>
  }

  return (
    <div className="taxpayer-app">
      
      <div className="taxpayer-header">
        <h1>Taxpayer Summary</h1>
        <p>Disclaimer: All information contained herein is proprietary to T-COT and is provided solely for the purpose of obtaining a contract with T-COT. Unauthorized use, disclosure, or distribution of this information is strictly prohibited. Any other use of this information without the express written consent of T-COT is not permitted.</p>
      </div>
      
      <div className="taxpayer-all">

        <div className="taxpayer-info">

          <ul className="info-list">
            <p> {tpName} </p>
            <li key={"taxpayerNumber"}>
              {"Taxpayer Number: " + tempTP}
            </li>
            <li key={"operatorNumber"}>
              {"Operator Number: " + taxpayerInfo.OperatorID} 
            </li>
            <li>
              {"Updated: " + lastUpdatedDate}
            </li>

            {(taxpayerInfo['ClientStatus'] !== null) && 
            <li key={"clientStatus"}>
              {"Client Status: " + taxpayerInfo['ClientStatus']}
            </li>
            }

            {(clientInfo['clientStatus'] !== null && clientInfo['auditor'] !== null) && 
            <li key={"auditorAssigned"}>
              {"Assigned to: " + clientInfo['auditor']}
            </li>
            }

            {(clientInfo['clientStatus'] !== null && clientInfo['auditor'] !== null) && 
            <li key={"expirationDate"}>
              {"Expiration Date: " + taxpayerInfo['ExpirationDate']}
            </li>
            }
            
            {taxpayerInfo['MKT RPT NOTE'] !== null &&
              <li key={"clientNote"}>
                {"Client Note:"}&nbsp;<strong><a style={{color:'red'}}>{taxpayerInfo['MKT RPT NOTE']}</a></strong>
              </li>
            }

            {( (taxpayerInfo.NewWellsDrilled === null || taxpayerInfo.NewWellsDrilled === '0' || taxpayerInfo.NewWellsDrilled < 10) && (parseFloat((taxpayerInfo.LowPro ?? '0').replace(',', '')) + parseFloat((taxpayerInfo.HighCost ?? '0').replace(',', '')) + parseFloat((taxpayerInfo.TwoYrInactive ?? '0').replace(',', '')) < 1000) ) &&
              <li key={"extraNote"}>
                {"Note:"}&nbsp;<strong><a style={{color:'red'}}>CONTACT HOME OFFICE BEFORE REACHING OUT.</a></strong>
              </li>
            }

            <li key={"address"}>
              {"Address: " + address}
            </li>
            <li key={"phoneNumber"}>
              {"Phone Number: " + phoneNumber}
            </li>
          </ul>
          
        </div>

        <div className='middle-div'></div>

        <div className="refund-info">
          
          <ul className="refund-list">
            <p>Refund Estimates</p>
            <li key={"lowpro"}>
              {(isAdmin && taxpayerInfo['LowPro'] !== '0.00') &&
              <a onClick={lowProToExcel}> {"Low Production: " + taxpayerInfo['LowPro']} </a>}
              {(!isAdmin || taxpayerInfo['LowPro'] === '0.00') && 
              "Low Production: " + taxpayerInfo['LowPro']}
            </li>
            {lowProExpiring !== '0.00' &&
              <li key={"lowProExpiring"}>
                {"LowPro Expiring by 20th of this month: " + lowProExpiring}
              </li>
            }
            <li key={"marketingCosts"}>
              {(isAdmin && mktcosts !== '0.00') && 
              <a onClick={mktCostsToExcel}> {"Marketing Costs Range: " + mktcosts} </a>}
              {(!isAdmin || mktcosts === '0.00') &&
              "Marketing Costs Range: " + mktcosts}
            </li>
            <li key={"highCost"}>
              {(isAdmin && taxpayerInfo['HighCost'] !== '0.00') && 
              <a onClick={highCostToExcel}> {"High Cost: " + taxpayerInfo['HighCost']} </a>}
              {(!isAdmin || taxpayerInfo['HighCost'] === '0.00')&&
              "High Cost: " + taxpayerInfo['HighCost']}
            </li>
            {highCostExpiring !== '0.00' &&
              <li key={"highCostExpiring"}>
                {"High Cost Expiring within 35 days: " + highCostExpiring}
              </li>
            }
            <li key={"gor"}>
              {"GOR: " + null}
            </li>
            <li key={"twoYearInactive"}>
              {(isAdmin && taxpayerInfo['TwoYrInactive'] !== '0.00') && 
              <a onClick={twoYrToExcel}> {"Two Year Inactive: " + taxpayerInfo['TwoYrInactive']} </a>}
              {(!isAdmin || taxpayerInfo['TwoYrInactive'] === '0.00') &&
              "Two Year Inactive: " + taxpayerInfo['TwoYrInactive']}
            </li>
            <li key={"flare"}>
              {"Flare: " + null}
            </li>
            <li key={"totalRefund"}>
              {"Total Refund: " + taxpayerInfo['Refund']}
            </li>
          </ul>
        </div>

        <div className='middle-div2'></div>

        <div className="well-info">
          <ul className = "wellInfo">

            <p>Well Information</p>
            
            <li key={"wellsDrilledLast"}>
              {"New Wells Drilled: " + taxpayerInfo['NewWellsDrilled']}
            </li>

            <li key={"recompletions"}>
              {"Recompletions: " + recompletions}
            </li>

            <li key={"newDP"}>
              {"New Drill Permits: " + taxpayerInfo['NumOfPermits']}
            </li>

            <li key={"oilWells"}>
              {"Operated Oil Wells: "}
            </li>
            
            <li key={"oil2026"}>
              {"2026: " + taxpayerInfo['Oil_2026']}
            </li>
            <li key={"oil2025"}>
              {"2025: " + taxpayerInfo['Oil_2025']}
            </li>
            <li key={"oil2024"}>
              {"2024: " + taxpayerInfo['Oil_2024']}
            </li>
            <li key={"oil2023"}>
              {"2023: " + taxpayerInfo['Oil_2023']}
            </li>
            <li key={"oil2022"}>
              {"2022: " + taxpayerInfo['Oil_2022']}
            </li>

            <li key={"gasWells"}>
              {"Operated Gas Wells: "}
            </li>
            <li key={"gas2026"}>
              {"2026: " + taxpayerInfo['Gas_2026']}
            </li>
            <li key={"gas2025"}>
              {"2025: " + taxpayerInfo['Gas_2025']}
            </li>
            <li key={"gas2024"}>
              {"2024: " + taxpayerInfo['Gas_2024']}
            </li>
            <li key={"gas2023"}>
              {"2023: " + taxpayerInfo['Gas_2023']}
            </li>
            <li key={"gas2022"}>
              {"2022: " + taxpayerInfo['Gas_2022']}
            </li>
          </ul>
          
        </div>
        
        <div className='middle-div3'></div>
        
        <div className="officer-info">
          <ul className='officer-list'>
            <li>
              {!showOfficers && <button onClick={changeOfficers}>Show Company Officers</button>}
              {showOfficers && <button onClick={changeOfficers}>Hide Company Officers</button>}
            </li>
            {showOfficers && officers.map((officerObj, i) => (
              <li>{officerObj.Title}: {officerObj.Name}</li>
            ))}
          </ul>
        </div>
      </div>

    </div>
  );
}

export default Taxpayer;